export const hasSpacingIssue = (text) => {
  if (!text) return false;

  return (
    text !== text.trim() || // leading/trailing spaces
    text.includes('  ') // double spaces inside
  );
};

export const cleanText = (text) => {
  return text?.trim().replace(/\s+/g, ' ');
};

export const isValidName = (text) => {
  return /^[A-Za-z]+( [A-Za-z]+)*$/.test(text);
};

// ✅ Email validation (practical, not overkill)
export const isValidEmail = (email) => {
  if (!email) return false;

  const cleaned = email.trim();

  // reject spaces anywhere
  //   if (cleaned.includes(" ")) return false;

  // basic email regex (covers most real cases)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(cleaned);
};
